import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { AuditEnriched } from '@app/_models';
import { AuditService, AlertService } from '@app/_services';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-audit-enriched-list',
    templateUrl: './audit-enriched-list.component.html',
    styleUrls: ['./audit-enriched-list.component.css'],
    standalone: false
})
export class AuditEnrichedListComponent implements OnInit
{
	@Input() auditUrl: string;
	@Input() source: string;
	@ViewChild('pt') table: Table;

	datasource: AuditEnriched[];
	audits: AuditEnriched[] = [];
	columns: any[];
	loading = false;

	constructor(
		private auditService: AuditService,
		private alertService: AlertService
	) {}

	ngOnInit()
	{
		try
		{
			this.columns = [
				{ field: 'id', header: 'Id' },
				{ field: 'commitDate', header: 'Date' },
				{ field: 'author', header: 'Changed By' },
				{ field: 'label', header: 'Change' },
				{ field: 'childType', header: 'Type' },
				{ field: 'childId', header: 'Object Id' },
				{ field: 'propertyName', header: 'Field' },
				{ field: 'left', header: 'Old' },
				{ field: 'right', header: 'New' }
			];

			if (!this.auditUrl || this.auditUrl.includes('undefined'))
			{
				return;
			}
			this.loading = true;
			this.auditService.findAll(this.auditUrl, this.source).pipe(first()).subscribe(
				response =>
				{
					const enriched = response?.data?.audits?.enrichedChanges || response?.data?.enrichedChanges || [];
					for (const item of enriched)
					{
						const flattened: AuditEnriched = {
							id: item.Id,
							author: item.author,
							commitDate: item.commitDate ? new Date(item.commitDate) : undefined,
							label: item.label,
							childType: item.childType,
							childId: item.childId,
							propertyName: item.propertyName,
							left: item.left,
							right: item.right
						};
						this.audits.push(flattened);
					}
					this.datasource = this.audits;
					this.audits = this.audits;
					setTimeout(() => { this.table?.reset(); }, 0);
				},
				error =>
				{
					console.log('AUDIT ENRICHED LIST!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() => { this.loading = false; }
			);
		} catch (error)
		{
			console.log('ngOnInit() ' + error);
		}
	}
}


